import { projects } from "../../config";
import { Fade } from 'react-awesome-reveal';

// Projects 
const Project = () => {

    return (
        <div name='project' className='mx-2 my-12 py-20 pb-12'>
            <div className='p-7 text-2xl text-center font-semibold'>
                Projects
            </div>
            <Fade>
                {projects.map((project , index) => {
                    return (
                        <div className='mx-2 my-8 shadow-[rgba(27,46,247,0.3)_0px_0px_15px_0px] rounded-xl sm:flex' key={index}>
                                <img
                                    src={project.image}
                                    alt={project.name}
                                    className="h-80 rounded-xl brightness-100"
                                />
                            
                            <div className="my-4 p-4">
                                <div className='m-2 text-xl'>
                                    {project.name}
                                </div>
                                <div className='px-2 py-4'>
                                    {project.description}
                                </div>
                                <div className='px-2 py-4 flex gap-4'>
                                    <a href={project.github}>
                                        <span
                                            className='text-white bg-indigo-900 p-2 rounded-xl'
                                        >
                                            Github
                                        </span>
                                    </a>
                                    <a href={project.website}>
                                        <span
                                            className='text-white bg-indigo-900 p-2 rounded-xl'
                                        >
                                            website
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Fade>
        </div>
    );
}

export default Project;
